import React from 'react'
import { Space, Input, Tooltip, Popconfirm } from 'antd'
import { Button, ButtonActionBar, DropdownMenu } from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import { SolutionOutlined } from '@ant-design/icons'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

const { Search } = Input

const UserActions = ({
  setSearchValue,
  onClick,
  onClickDownload,
  onClickSettings,
  disabled,
  onClickActivity,
  loading,
  onConfirmPopConfirmMirror,
  onCancelPopConfirmMirror,
  visibleMirror,
  onClickMirror,
  disabledMirror,
}) => {
  const { t } = useTranslation()
  const enabledMirror = useFeatureIsOn('ab_dimension_mirror')
  return (
    <ButtonActionBar>
      <Space size="middle">
        <Search
          className="dimension-search"
          placeholder={t('ACTION_SEARCH')}
          allowClear={true}
          onSearch={setSearchValue}
        />
        <Button.Primary onClick={onClick} disabled={disabled} title="ACTION_CREATE_NEW" />
        <Button.PrimaryGhost
          onClick={onClickDownload}
          disabled={disabled}
          title="ACTION_UPLOAD_FILE"
        />
        {enabledMirror && (
          <Popconfirm
            title={t('CONFIG_DIMENDIONS_VALUES_MIRROR_DATA_POPCONFIRM_TITLE')}
            placement="right"
            okText={t('ACTION_MIRROR')}
            okButtonProps={{ loading }}
            cancelButtonProps={{ disabled: loading }}
            onConfirm={onConfirmPopConfirmMirror}
            cancelText={t('ACTION_CANCEL')}
            onCancel={onCancelPopConfirmMirror}
            visible={visibleMirror}
          >
            <Button.Default
              title="ACTION_MIRROR"
              onClick={onClickMirror}
              disabled={disabledMirror}
            />
          </Popconfirm>
        )}
        <Tooltip title={t('CONFIG_PREFERENCES_DIMENSIONS_INFORMATIVE_TOOLTIP_TITLE')}>
          <Button.Default
            title="CONFIG_SETTINGS_MODAL_TITLE"
            onClick={onClickSettings}
            disabled={disabled}
          />
        </Tooltip>
        <DropdownMenu
          title={t('ACTION_MORE')}
          menu={[
            {
              title: t('ACTION_ACTIVITIES'),
              icon: <SolutionOutlined />,
              onClick: onClickActivity,
            },
          ]}
        />
      </Space>
    </ButtonActionBar>
  )
}

export default UserActions
